import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ApiManager from "../../api/ApiManager";
import { RootState } from "../shopStore";

export interface fetchOrderInactiveInterface {
    traderId: string | number;
    date?: Date[];
}

export const fetchOrdersActive =
    createAsyncThunk('dashboard/fetchOrdersActive', (traderId: string | number) => ApiManager.fetchOrdersActive(traderId));

export const fetchOrdersInactive =
    createAsyncThunk('dashboard/fetchOrdersInactive', (arg: fetchOrderInactiveInterface, { getState }/*: fetchOrderInactiveInterface*/) => {
        const state = getState() as RootState
        let date = arg?.date || null;
        if (!date) {
            date = [
                new Date(state.orders.inactiveOrders.date.start),
                new Date(state.orders.inactiveOrders.date.end)
            ]
        }
        return ApiManager.fetchOrdersInactive({ traderId: arg.traderId, date: date })
    });


const today = new Date();
today.setHours(23, 59, 59, 999)
const startDate = new Date(today);
startDate.setMonth(startDate.getMonth() - 1);
startDate.setHours(0, 0, 0, 0)

const ordersSlice = createSlice({
    name: 'orders',
    initialState: {
        traderId: null as null | string | number,
        activeOrderId: null as null | string,
        firstOrderId: null as null | string,
        activeOrders: {
            data: [{
                internalNumber: '' as string
            }],
            valid: true,
            loaded: false,
            loading: false,
            error: null
        },
        inactiveOrders: {
            date: {
                start: startDate.toISOString(),
                end: today.toISOString()
            },
            data: [] as {}[],
            valid: true,
            loaded: false,
            loading: false,
            error: null
        },
        detailsOrders: {

            data: {
                products: [],
                currency: "PLN",
                orderedTime: ""
            },
            valid: true,
            loaded: false,
            loading: false,
            error: null
        },
    },
    reducers: {
        setTraderId: (state, action) => {
            state.traderId = action.payload
        },
        setFirstOrderId: (state, action) => {
            state.firstOrderId = action.payload
        },
        setActiveOrderId: (state, action) => {
            state.activeOrderId = action.payload
        },
        setDetailsOrdersLoading: (state, action) => {
            state.detailsOrders.loading = action.payload
        },
        setInactiveOrdersDate: (state, action) => {
            state.inactiveOrders.date.start = action.payload.start
            state.inactiveOrders.date.end = action.payload.end
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchOrdersActive.fulfilled, (state, action) => {
                state.activeOrders.data = Array.isArray(action.payload) ? action.payload : [];
                state.firstOrderId = action.payload.length ? action.payload[0].internalNumber : ""
                state.activeOrders.loaded = true
            })
            .addCase(fetchOrdersInactive.fulfilled, (state, action) => {
                state.inactiveOrders.data = Array.isArray(action.payload) ? action.payload : [];
                state.inactiveOrders.loaded = true
            })
    }
})
export const {
    setTraderId,
    setFirstOrderId,
    setActiveOrderId,
    setDetailsOrdersLoading,
    setInactiveOrdersDate
} = ordersSlice.actions
export default ordersSlice.reducer